/**
 * Définition du schéma Dexie (tables + index).
 * Version incrémentée à chaque évolution incompatible.
 */
export var DB_NAME = 'mares-db';

export var DB_VERSION = 2;

// Clé meta de migration JSON → Dexie
export var META_MIGRATED = 'migrated_v1';

/**
 * Stores Dexie v1 (référence upgrade).
 */
export var STORES_V1 = {
	meta: 'key',
	zones: 'id, status, is_active, minLng, minLat, maxLng, maxLat, updated_at, *zips',
	ponds: 'uuid, id, zone_id, lat, lng, user_uuid, updated_at, todo',
	visits: 'uuid, id, pond_uuid, user_uuid, updated_at, todo',
	images: 'uuid, id, pond_uuid, user_uuid, updated_at, todo',
	user: 'key',
	data: 'key',
};

/**
 * Stores Dexie v2.
 * Index composé [user_uuid+created_at] pour listes « Mes mares / Mes visites ».
 */
export var STORES = {
	meta: 'key',
	zones: 'id, status, is_active, minLng, minLat, maxLng, maxLat, updated_at, *zips',
	ponds: 'uuid, id, zone_id, lat, lng, user_uuid, updated_at, todo, [user_uuid+created_at]',
	visits: 'uuid, id, pond_uuid, user_uuid, updated_at, todo, [user_uuid+created_at]',
	images: 'uuid, id, pond_uuid, user_uuid, updated_at, todo',
	user: 'key',
	data: 'key',
};
